



import IMapProperty from './private/IMapProperty';


const MAPPINGS: Array<IMapProperty> = [
{
    'localName' : 'id',
    'externalName' : 'id',
    'defaultValue' : 0,
},
{
    'localName' : 'name',
    'externalName' : 'name',
    'defaultValue' : '',
},
{
    'localName' : 'fontColor',
    'externalName' : 'fontColor',
    'defaultValue' : '',
},
{
    'localName' : 'fontSize',
    'externalName' : 'fontSize',
    'defaultValue' : 0,
},
{
    'localName' : 'fontName',
    'externalName' : 'fontName',
    'defaultValue' : '',
},
{
    'localName' : 'backgroundColor',
    'externalName' : 'backgroundColor',
    'defaultValue' : '',
},
{
    'localName' : 'foregroundColor',
    'externalName' : 'foregroundColor',
    'defaultValue' : '',
},
{
    'localName' : 'description',
    'externalName' : 'description',
    'defaultValue' : '',
},
{
    'localName' : 'siteId',
    'externalName' : 'siteId',
    'defaultValue' : 0,
},
{
    'localName' : 'tourTypeId',
    'externalName' : 'tourTypeId',
    'defaultValue' : 0,
},
{
    'localName' : 'tourSubTypeId',
    'externalName' : 'tourSubTypeId',
    'defaultValue' : 0,
},
{
    'localName' : 'styleId',
    'externalName' : 'styleId',
    'defaultValue' : 0,
},
{
    'localName' : 'tourStatusId',
    'externalName' : 'tourStatusId',
    'defaultValue' : 0,
},
{
    'localName' : 'stage1',
    'externalName' : 'stage1',
    'defaultValue' : false,
},
{
    'localName' : 'stage2',
    'externalName' : 'stage2',
    'defaultValue' : false,
},
{
    'localName' : 'stage3',
    'externalName' : 'stage3',
    'defaultValue' : false,
},
{
    'localName' : 'stage4',
    'externalName' : 'stage4',
    'defaultValue' : false,
},
{
    'localName' : 'createdById',
    'externalName' : 'createdById',
    'defaultValue' : 0,
},
{
    'localName' : 'modifiedById',
    'externalName' : 'modifiedById',
    'defaultValue' : 0,
},
{
    'localName' : 'version',
    'externalName' : 'version',
    'defaultValue' : 0,
},
{
    'localName' : 'minorVersion',
    'externalName' : 'minorVersion',
    'defaultValue' : 0,
},
{
    'localName' : 'publishedVersion',
    'externalName' : 'publishedVersion',
    'defaultValue' : 0,
},
{
    'localName' : 'testVersion',
    'externalName' : 'testVersion',
    'defaultValue' : 0,
},
];

export default MAPPINGS;

